import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth, db } from '../config/firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Verificar si un email está en la whitelist
 */
export const isEmailAuthorized = async (email) => {
  try {
    const configRef = doc(db, 'config', 'allowedEmails');
    const configSnap = await getDoc(configRef);
    
    if (configSnap.exists()) {
      const allowedEmails = configSnap.data().email || [];
      return allowedEmails.includes(email.toLowerCase());
    }
    return false;
  } catch (error) {
    console.error('Error checking email authorization:', error);
    return false;
  }
};

/**
 * Registrar usuario (sin restricción de whitelist)
 */
export const registerUser = async (email, password) => {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('Error registering user:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Login de usuario
 */
export const loginUser = async (email, password) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('Error logging in:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Logout
 */
export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('Error logging out:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener usuario actual
 */
export const getCurrentUser = () => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Verificar que siga siendo autorizado
        const authorized = await isEmailAuthorized(user.email);
        resolve(authorized ? user : null);
      } else {
        resolve(null);
      }
      unsubscribe();
    });
  });
};
